module.exports = __webpack_public_path__ + "static/civic-logo-c-4859c31aa538ff3f9c4fae6dae761d65.svg";